import React from 'react';
import {
  IconPaint, IconAiPencil, IconCopyFile, IconAiText, IconAiSelection,
  Link,
} from 'gatorcomponents';
import { FILTER_CATEGORIES } from '@/pages/Studio/studio.enum';

export default {
  tag: {
    label: 'Pro',
    youArePro: 'Eres PRO',
  },
  studioTitle: {
    pro: 'HostGator Studio Pro',
    free: 'HostGator Studio',
  },
  logoBuilder: 'Creador de logotipos',
  modalInitialQuestions: {
    title: 'Personalizaremos el Estudio Gratuito según tus preferencias.',
    titlePro: 'Personalizaremos Studio Pro según tus preferencias.',
    buttonContinue: 'Continuar',
    buttonBack: 'Volver',
    labelQuestion1: '¿Qué quieres crear con Studio?',
    labelQuestion2: '¿Cuál es el área de su negocio o proyecto?',
    labelQuestion3: '¿Has utilizado otras plataformas de design?',
    question1: {
      logo: 'Logotipo y elementos de identidad visual',
      socialMedia: 'Contenido para redes sociales (Instagram, Facebook, etc...)',
      marketing: 'Materiales de marketing y ventas',
      ecommerce: 'Elementos y contenidos para tienda online',
      graphic: 'Materiales de impresión',
      others: 'Otros',
    },
    question3: {
      yes: 'Sí',
      no: 'Es la primera vez',
    },
    errorDescription: (
      <>
        Ocurrió un error al continuar.
        <br />
        {' '}
        Si persiste, inténtalo nuevamente más tarde.
      </>
    ),
    buttonError: 'Ok, lo entiendo',
  },
  bussinessCategories: {
    accounting: 'Contabilidad',
    architecture: 'Arquitectura',
    artificialIntelligence: 'Inteligencia Artificial',
    bakeries: 'Panaderías',
    carRentals: 'Alquiler de Coches',
    clinicsAndPractices: 'Clínicas y Consultorios',
    clothingAndAccessories: 'Ropa y Accesorios',
    clothingStores: 'Tiendas de Ropa',
    constructionAndRealEstate: 'Construcción e Inmobiliaria',
    corporateTraining: 'Entrenamientos Corporativos',
    educationAndTraining: 'Educación y Entrenamiento',
    ecotourism: 'Ecoturismo',
    electronics: 'Electrónica',
    entertainmentAndArts: 'Entretenimiento y Artes',
    eventsAndConcerts: 'Eventos y Conciertos',
    fashionAndClothing: 'Moda y Vestimenta',
    financeAndLegal: 'Finanzas y Jurídico',
    fintechs: 'Fintechs',
    fitness: 'Fitness',
    foodAndBeverage: 'Alimentos y Bebidas',
    foodDelivery: 'Entrega de Comida',
    footwear: 'Calzado',
    gamesAndApps: 'Juegos y Aplicaciones',
    groupsMusicals: 'Grupos Musicales',
    healthAndWellbeing: 'Salud y Bienestar',
    hotelsAndInns: 'Hoteles y Posadas',
    interiorDesignAndDecoration: 'Decoración y Diseño de Interiores',
    investments: 'Inversiones',
    jewelryAndWatches: 'Joyas y Relojes',
    languages: 'Idiomas',
    lawFirms: 'Despachos de Abogados',
    landscaping: 'Paisajismo',
    luxuryBrands: 'Marcas de Lujo',
    marketingAndCommunication: 'Marketing y Comunicación',
    mentalHealth: 'Salud Mental',
    deliveryService: 'Servicio de entrega',
    naturalProducts: 'Productos Naturales',
    onlineCourses: 'Cursos en Línea',
    pastriesAndBakeries: 'Pastelerías y Panaderías',
    petStores: 'Tiendas de Mascotas',
    photographyStudios: 'Estudios de Fotografía',
    publicRelations: 'Relaciones Públicas',
    realEstate: 'Inmobiliarias',
    resorts: 'Resorts',
    restaurantsAndCafes: 'Restaurantes y Cafeterías',
    retailAndCommerce: 'Venta al por Menor y Comercio',
    schoolsAndUniversities: 'Escuelas y Universidades',
    softwareDevelopment: 'Desarrollo de Software',
    startups: 'Startups',
    supermarkets: 'Supermercados',
    sustainableFashion: 'Moda Sostenible',
    technologyAndInnovation: 'Tecnología e Innovación',
    transportAndLogistics: 'Transporte y Logística',
    transporters: 'Transportistas',
    tourismAndHospitality: 'Turismo y Hospitalidad',
    videoProduction: 'Producción de Videos',
    others: 'Otros',
  },
  topBanner: {
    free: 'HostGator Studio',
    pro: 'HostGator Studio Pro',
    title: (
      <>
        Crea diseños increíbles para tu marca
        <br />
        {' '}
        con el poder de la Inteligencia Artificial
      </>
    ),
    ButtonLabel: 'Empiece con Pro',
    credits: ' créditos',
    forYou: 'Para ti',
    design: 'Diseño',
    projects: 'Proyectos',
    createAiSite: 'Crear un sitio web con IA',
    alertTitle: days => `Recordatorio: Quedan ${days} días para que termine tu prueba.`,
    alertDescription: price => (
      <>
        Continúa disfrutando de todos los beneficios del Pro. Vamos a debitar en los próximos días el monto de
        {' '}
        <span className="text-price">{price}</span>
        {' '}
        en la tarjeta registrada.
      </>
    ),
    creditAnalysis: {
      yourPlan: 'Tu plan',
      creditsUsedPercentage: percentage => `Has usado el ${percentage}% de tus créditos`,
      creditsHasEndedUpgrade: 'Tus créditos se han agotado. Mejora tu plan para utilizar las funciones de Studio Pro, o espera hasta la renovación.',
      creditsHasEnded: 'Tus créditos se han agotado. Espera hasta la renovación el próximo mes.',
      creditsUsed: quantity => (
        <>
          <strong>{quantity}</strong>
          {' Créditos utilizados'}
        </>
      ),
      creditsAvailable: quantity => (
        <>
          {'Créditos disponibles '}
          <strong>{quantity}</strong>
        </>
      ),
      nextRecharge: dateString => (
        <>
          {'Próxima recarga de créditos el '}
          <strong>
            {dateString}
          </strong>
        </>
      ),
      upgradePlan: 'Mejora tu plan y obtén créditos extra para seguir creando.',
      goToProButtonLabel: 'Ir a Pro',
      learnMore: (
        <>
          {'Los créditos se utilizan para crear diseños con IA. '}
          <Link
            text="Saber más."
            href="https://soporte.hostgator.mx/hc/es-419/articles/40042239323027-C%C3%B3mo-funcionan-los-cr%C3%A9ditos-en-HG-Studio"
            target="_blank"
          />
        </>
      ),
    },
    alertTitleNoCard: 'Su período de prueba está por terminar',
    alertDescriptionNoCard: 'No se quede sin los recursos de Pro: adquiéralo ahora mismo y continúe disfrutando de los beneficios.',
    ctaNoCard: 'Activar el plan Pro',
  },
  highlightFeatures: {
    tag: {
      label: 'Pro',
      credits: {
        prefix: 'Consume',
        singularSuffix: 'crédito',
        pluralSuffix: 'créditos',
      },
    },
    header: {
      titleFeatures: 'Domina el arte de crear con Pro',
      labelButtonAi: 'Crear un sitio web con IA',
    },
    logoBuilder: {
      title: 'Creador de logotipos con IA',
      description: 'Crea logotipos profesionales para tu marca.',
    },
    scaleDesign: {
      title: 'Diseño a escala',
      description: 'Acelere su proceso creativo a escala.',
    },
    backgroundRemover: {
      title: (
        <>
          Eliminar el fondo con IA
        </>
      ),
      description: 'Retirar fondos en segundos',
    },
    brandKit: {
      title: 'Kit de marca',
      description: (
        <>
          Tu fuerte
          <br />
          {' '}
          identidad visual
          <br />
          {' '}
          en todos
          <br />
          {' '}
          los canales
        </>
      ),
    },
  },
  modalFeaturePro: {
    title: {
      BACKGROUND_REMOVER: (
        <>
          Elimina el fondo de tus imágenes
          <br />
          con la comodidad de la IA
        </>
      ),
      BRAND_KIT: (
        <>
          Crea tu kit de marca con el
          <br />
          poder de la IA
        </>
      ),
      LOGO_BUILDER: (
        <>
          Crea logotipos profesionales con el
          <br />
          poder de la IA
        </>
      ),
      SCALE_DESIGN: (
        <>
          Diseño a escala con el
          <br />
          poder de la IA
        </>
      ),
      NO_CREDITS: (
        <>
          Has alcanzado el límite de crédito para
          <br />
          utilizar las funciones de IA.
        </>
      ),
      STUDIO_PRO: (
        <>
          Hazte Pro y obtén acceso a todas
          <br />
          las funciones del Studio.
        </>
      ),
      STUDIO_PRO_TRIAL: (
        <>
          Prueba el plan Pro por
          {' '}
          <strong>7 días</strong>
          {' '}
          y accede a todos los recursos.
        </>
      ),
      STUDIO_PRO_OFFER: 'Sea Pro y cree diseños creativos',
    },
    textStudioPro: planPrice => `Aprovecha el Pro por ${planPrice} al mes`,
    textStudioProTrial: 'Prueba el plan y obtén resultados profesionales',
    textStudioFree: planPrice => `Prueba Pro por ${planPrice} al mes`,
    textStudioTrial: (
      <>
        Pruebe Studio Pro durante
        {' '}
        <strong>7 días gratis</strong>
        {' '}
        no se requiere tarjeta de crédito
      </>
    ),
    listFeaturesPro: {
      brandKit: {
        text: 'Kit de marca para crear diseños consistentes utilizando los colores y patrones de su marca.',
        icon: <IconPaint color="primaryBlue" size="md" />,
      },
      logoBuilder: {
        text: 'Creador de logotipos con IA',
        icon: <IconAiPencil color="primaryBlue" size="md" />,
      },
      templates: {
        text: 'Miles de plantillas para ayudarte a empezar',
        icon: <IconCopyFile color="primaryBlue" size="md" />,
      },
      filterFontsTemplates: {
        text: 'Filtros, fuentes y plantillas premium',
        icon: <IconAiText color="primaryBlue" size="md" />,
      },
      advancedFeatures: {
        text: 'Funciones avanzadas en el editor',
        icon: <IconAiSelection color="primaryBlue" size="md" />,
      },
    },
    buttonGoPlansLabel: 'Ver detalles del plan',
    buttonFreeLabel: 'Go Pro',
    buttonTrialLabel: 'Prueba gratis',
    buttonOfferTrialLabel: 'Activa 7 días gratis',
    buttonOkLabel: 'Ok, lo entiendo',
    buttonNotNowLabel: 'Ahora no',
    textCancellation: 'Cancelar en cualquier momento.',
    titleNoCredits: 'Has alcanzado el límite de crédito para utilizar las funciones de IA.',
    textNoCredits: 'Tus créditos se recargarán el %date%',
    textNoCreditsFree: 'Tus créditos se recargarán el  %date%. Hazte Pro y renueva tus créditos ahora mismo.',

    purchaseTrial: {
      title: 'Crea con Pro gratis',
      description: (discount = 30) => (
        <>
          {'¡Gana más pagando menos! Suscríbete ahora con tarjeta de crédito y obtén '}
          <strong>{`${discount} de descuento.`}</strong>
        </>
      ),
      options: {
        creditCard: {
          title: 'Prueba con tarjeta de crédito',
          discount: value => (
            <>
              {'Descuento de '}
              <strong>{`${value}% de descuento`}</strong>
            </>
          ),
          price: value => (
            <strong>
              {'Precio: '}
              {value}
              {' / mes'}
            </strong>
          ),
          bottomText: 'Cancela cuando quieras',
        },
        noCreditCard: {
          title: 'Prueba sin tarjeta de crédito',
          description: 'Prueba gratis por 7 días, sin cargos.',
          price: value => (
            <>
              <strong>{`Precio: ${value} / `}</strong>
              mes después de la prueba
            </>
          ),
        },
      },
      cancelButtonLabel: 'Cancelar',
      continueButtonLabel: 'Continuar',
      bottomMessage: (
        <>
          {'Al continuar, aceptas los '}
          <Link text="Términos de Uso" href="https://soporte.hostgator.mx/hc/es-419/articles/39904309293459-T%C3%A9rminos-de-uso-de-Titan-de-HostGator-Studio" />
          {' aplicables a Studio Pro y confirmas que has leído nuestra '}
          <Link text="Política de Privacidad." href="https://www.newfold.com/privacy-center/privacy" />
        </>
      ),

      howTestWorks: 'Cómo funciona la prueba',
      timeline: {
        startOfTest: {
          title: (
            <>
              <strong>{'Hoy '}</strong>
              {' Inicio de la prueba'}
            </>
          ),
          description: 'Acceso a todas las funcionalidades del plan Pro, incluyendo diseños con IA.',
        },
        reminderOfTest: {
          title: (
            <>
              <strong>{'En 5 días '}</strong>
              {' Recordatorio'}
            </>
          ),
          description: 'Te avisaremos cuando el final de la prueba esté cerca.',
        },
        endOfTest: {
          title: (
            <>
              <strong>{'Después de 7 días '}</strong>
              {' Inicio de la suscripción'}
            </>
          ),
          description: value => (
            <>
              {'El plan Pro se cobrará solo '}
              <strong>
                a quienes eligieron probar con tarjeta de crédito
              </strong>
              {` por un valor de ${value}`}
            </>
          ),
        },
        bottomText: 'Cancela cuando quieras. Te recordaremos antes de que termine el período de prueba.',
      },
    },
  },
  modalLogoGeneration: {
    createYourLogoInSeconds: 'Crea tu logo en segundos',
    tellUsAboutYourBrand: 'Cuéntanos un poco sobre tu marca',
    brandName: '¿Cuál es el nombre de tu marca?',
    brandSlogan: 'Describa su marca',
    category: 'Selecciona la categoría de la empresa',
    categories: [
      'Alimentación y Bebidas',
      'Arquitectura',
      'Calzado',
      'Clínicas y Consultorios',
      'Construcción e Inmobiliaria',
      'Contabilidad',
      'Cursos en Línea',
      'Decoración y Diseño de Interiores',
      'Desarrollo de Software',
      'Pastelerías y Panaderías',
      'Ecoturismo',
      'Educación y Entrenamiento',
      'Electrónica',
      'Ingeniería Civil',
      'Entrega de Comida',
      'Entretenimiento y Artes',
      'Escuelas y Universidades',
      'Despachos de Abogados',
      'Estética y Belleza',
      'Estudios de Fotografía',
      'Eventos y Conciertos',
      'Finanzas y Jurídico',
      'Fintechs',
      'Fitness',
      'Grupos Musicales',
      'Hoteles y Posadas',
      'Idiomas',
      'Inmobiliarias',
      'Inteligencia Artificial',
      'Inversiones',
      'Juegos y Aplicaciones',
      'Joyas y Relojes',
      'Alquiler de Coches',
      'Tiendas de Ropa',
      'Marcas de Lujo',
      'Marketing y Comunicación',
      'Moda y Vestimenta',
      'Moda Sostenible',
      'Panaderías',
      'Paisajismo',
      'Tiendas de Mascotas',
      'Producción de Videos',
      'Productos Naturales',
      'Relaciones Públicas',
      'Resorts',
      'Restaurantes y Cafeterías',
      'Ropa y Accesorios',
      'Salud y Bienestar',
      'Salud Mental',
      'Servicio de entrega',
      'Supermercados',
      'Tecnología e Innovación',
      'Transporte',
      'Entrenamientos Corporativos',
      'Turismo y Hospitalidad',
      'Venta al por Menor y Comercio',
    ],
    selectColor: 'Selecciona el color que mejor represente tu marca',
    selectCustomColor: 'Color secundario (Opcional)',
    colors: [
      {
        name: 'Negro',
        code: 'black',
        background: '#000000',
      },
      {
        name: 'Azul',
        code: 'blue',
        background: '#3897F0',
      },
      {
        name: 'Morado',
        code: 'purple',
        background: '#785CFF',
      },
      {
        name: 'Verde',
        code: 'green',
        background: '#2EB67D',
      },
      {
        name: 'Rosa',
        code: 'pink',
        background: '#FF35AE',
      },
      {
        name: 'Amarillo',
        code: 'yellow',
        background: '#F4DD08',
      },
      {
        name: 'Naranja',
        code: 'orange',
        background: '#FF9900',
      },
      {
        name: 'Rojo',
        code: 'red',
        background: '#FF4B56',
      },
    ],
    customColorObject: {
      name: 'Customizado',
      code: 'custom',
      background: '#FFFFFF',
    },
    buttonBackLabel: 'Volver',
    buttonCreateLabel: 'Crear logo',
    errorMessage: 'Selecciona un color y completa los elementos obligatorios antes de continuar',
    helpTextSlogan: 'Ejemplo: Restaurante de comida saludable con especialidad en ensaladas',
    generatingLogo: 'Estamos solicitando tu logo profesional, un momento...',
    noCredits: date => `Tus créditos se han agotado y se renovarán automáticamente el ${date}.`,
    noCreditsForLogoBuilder: 'Tus créditos no son suficientes para generar más logos. Para continuar, crea manualmente.',
    buttonGoStudio: {
      labelFree: 'Ir al Studio Gratis',
      labelPro: 'Ir al Studio Pro',
    },
    buttonRetryLabel: 'Generar más opciones',
    textRetry: retryQty => `Aún puede generar ${retryQty} ${retryQty > 1 ? 'logos' : 'logo'} con sus créditos actuales.`,
    buttonCreateLogoManuallyLabel: 'Crear logo manualmente',
    buttonGoProLabel: 'Hazte Pro',
    titleCreatingLogos: 'Creando tus logos, un momento...',
    titleLogosCreated: 'Hemos creado %number% variaciones de logotipo para ti',
    titleError: (
      <>
        Se produjo un error al generar su logotipo.
        <br />
        Si persiste, inténtalo de nuevo más tarde.
      </>
    ),
    buttonErrorLabel: 'Intentar otra vez',
    logosInfoText: (count, creditsSpent) => `Se generarán ${count} logos y se gastarán ${creditsSpent} créditos`,
    credits: 'créditos',
    remainingCharactersLabel: 'Caracteres restantes:',
  },
  bannerOfferPro: {
    title: 'Sea Pro',
    description: 'Obtenga acceso a una experiencia premium al crear su obra de arte, con plantillas seleccionadas y un alto potencial de conversión.',
    buttonLabel: 'Disfruta el Pro',
  },
  buttonCreateSiteAi: {
    label: 'Crear un sitio web con IA',
  },
  headerDesignSection: {
    headerText: 'Elige plantillas para tu creación',
    tooltip: 'Crear nuevo proyecto',
    filterCategories: {
      [FILTER_CATEGORIES.social]: 'Redes sociales',
      [FILTER_CATEGORIES.marketing]: 'Marketing',
      [FILTER_CATEGORIES.impression]: 'Impresión',
      [FILTER_CATEGORIES.links]: 'Enlaces',
      [FILTER_CATEGORIES.ebook]: 'E-libro',
    },
  },
  templateList: {
    seeMore: 'Mostrar más',
    showMoreTemplates: 'Mostrar más plantillas',
    emptyState: 'No se han encontrado resultados para su búsqueda',
    formats: {
      pack_instagram: 'Pack de Instagram',
      instagram_post: 'Post para Instagram',
      insta_stories: 'Historias para Instagram',
      global_facebook_post: 'Post para Facebook',
      global_facebook_vertical: 'Historias para Facebook',
      capa_youtube: 'Portada para Youtube',
      icone_youtube: 'Ícono de Youtube',
      global_whatsapp_post: 'Post para WhatsApp',
      capa_tiktok: 'TikTok',
      catalogo_virtual: 'Catálogo',
      global_ebook_A4_Vertical: 'E-libro',
      mini_sites: 'Mini sitio',
      promo_link: 'Promociones',
      cardapio: 'Menú',
      cartao_de_visita: 'Tarjeta de Visita',
      panfletos: 'Folletos',
      cartaz_a2: 'Cartel A2',
      certificados_sympla: 'Certificados Sympla',
      certificado_evenbrite: 'Certificado Eventbrite',
      stories_facebook: 'Historias para Facebook',
      capa_facebook: 'Portada para Facebook',
      link_na_bio: 'Enlace en la Bio',
      anuncio_google: 'Anuncio de Google',
      anuncio_instagram: 'Anuncio de Instagram',
    },
    altText: 'foto de la plantilla',
  },

  modalPlanHireSuccess: {
    title: '¡Felicitaciones, ahora eres parte de Studio Pro!',
    description: 'Disfruta de todas las funciones avanzadas de IA y comienza a crear',
    buttonLabel: 'Comenzar a crear',
    animationAlt: 'animación de confeti',
    successAlt: 'imágenes diversas',
  },
  advertisingBanner: {
    badge: 'Gratis en tu plan',
    buttonLabel: {
      top: 'Acceder a Studio',
      bottom: 'Empezar',
    },
    title: {
      top: 'Crea un logo, post e imágenes: ¡Todo para destacar tu marca!',
      bottom: 'Crea diseños impresionantes con facilidad usando HostGator Studio',
    },
  },
};
